import React from 'react';
import styled, { css } from 'styled-components';
import { DATETIME } from '@/util/ColumnType';
import { formatCellValue } from '../utils';
import { CellCopyButton } from './CellCopyButton';
import { CellOpenValueButton } from './CellOpenValueButton';
import { ResultsOnboarding } from './ResultsOnboarding';

const CellContent = styled.div`
  position: relative;
  padding-left: 15px;
  padding-right: 10px;
  text-align: left;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${(p) =>
    p.$empty &&
    css`
      color: #ccc;
    `}
`;

const _CellButtons: React.FC<any> = ({ className, value, columnType }) => {
  return (
    <div className={className}>
      <CellCopyButton value={value} />
      <CellOpenValueButton value={value} columnType={columnType} />
    </div>
  );
};

const CellButtons = styled(_CellButtons)`
  --offset: 5px;

  display: flex;
  position: absolute;
  right: var(--offset);
  top: var(--offset);
  margin: auto;
`;

const isDefaultTime = (dateString: string) => {
  return dateString?.includes('00:00:00.000+00:00');
};

const _Cell: React.FC<any> = ({
  cellData,
  isResultsOnboardingShown,
  className,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const isEmpty = cellData.cell.isEmpty();
  const formattedCellValue = formatCellValue(
    cellData.cell,
    cellData.columnType._type,
  );

  let cellValue = cellData.cell._value;
  if (cellData.columnType._type === DATETIME && isDefaultTime(cellValue)) {
    cellValue = formattedCellValue;
  }

  return (
    <td
      rowSpan={cellData.rowspan}
      className={className}
      onMouseEnter={isEmpty ? undefined : () => setIsHovered(true)}
      onMouseLeave={isEmpty ? undefined : () => setIsHovered(false)}
    >
      <CellContent $empty={isEmpty}>{formattedCellValue}</CellContent>
      {isHovered && (
        <CellButtons value={cellValue} columnType={cellData.columnType._type} />
      )}
      {isResultsOnboardingShown && <ResultsOnboarding />}
    </td>
  );
};

const Cell = styled(_Cell).attrs((p) => ({
  className: p.className,
}))`
  ${(p) =>
    p.cellData.rowspan > 1 &&
    css`
      vertical-align: top;
      ${CellContent} {
        margin-top: 14px;
      }
    `}
`;

export const DrilldownCell = React.memo(Cell);
